import { ICreateCourseCertificate } from '@/types/courses';

export const createNewCertificate = (
  channel: number,
  courseId: number,
  designId: number,
  userId: number
): ICreateCourseCertificate => ({
  course_id: courseId,
  channel: channel,
  design_id: designId,
  email_body: {
    base: `Dear {{{first_name}}} {{{last_name}}},
Congratulations! You have passed {{{course_name}}} and received your certificate. It’s now available for download.`,
    changed: '',
  },
  email_subject: { base: 'Congratulations, you completed {{{course_name}}}', changed: '' },
  name: { base: '', changed: '' },
  created_by: userId,
  settings: {
    backgroundImage: '',
    icon: '',
  },
});
